document.addEventListener('DOMContentLoaded', function() {
  if (!document.querySelector('.product-page-container')) return;

  const addToCartButton = document.querySelector('.awo-add-product-builder-button');
  const productOptionCheckboxes = document.querySelectorAll('.product-option-checkbox-input');
  const priceContainer = document.querySelector('.product-current-price');
  const compareAtPriceContainer = document.querySelector('.product-compare-price');
  const enquiryButton = document.querySelector('#product-enquiry-button button');

  // Call this function immediately to initialize prices based on pre-selected options
  initializeWithSelectedOptions();

  // Then set up change listeners for future changes
  productOptionCheckboxes.forEach(option => {
    option.addEventListener('change', () => {
      updateTotalPrice();
      handleOptionSelection(option);
    });
  });

  // Handle option selection and local storage
  function handleOptionSelection(option) {
    const optionId = option.dataset.optionId;
    // Use current variant instead of the original parent product ID
    const currentVariant = addToCartButton ? addToCartButton.dataset.variant : option.dataset.parentProductId;
    let storedData = JSON.parse(localStorage.getItem('product_builder_options')) || {};

    if (!storedData[currentVariant]) {
      storedData[currentVariant] = {
        product_id: currentVariant,
        selected_product_options: []
      };
    }

    if (option.checked) {
      if (!storedData[currentVariant].selected_product_options.includes(optionId)) {
        storedData[currentVariant].selected_product_options.push(optionId);
      }
    } else {
      storedData[currentVariant].selected_product_options = 
        storedData[currentVariant].selected_product_options.filter(id => id !== optionId);
    }

    localStorage.setItem('product_builder_options', JSON.stringify(storedData));
  }

  // Load and check pre-selected options from localStorage
  function initializeWithSelectedOptions() {
    const storedData = JSON.parse(localStorage.getItem('product_builder_options')) || {};
    let hasSelectedOptions = false;
    
    // Get current variant
    const currentVariant = addToCartButton ? addToCartButton.dataset.variant : null;
    
    // First pass: mark options as checked for current variant
    productOptionCheckboxes.forEach(option => {
      const optionId = option.dataset.optionId;
      
      if (currentVariant && storedData[currentVariant] && 
          storedData[currentVariant].selected_product_options.includes(optionId)) {
        option.checked = true;
        option.closest('.option-label')?.classList.add('selected');
        hasSelectedOptions = true;
      }
    });
    
    // Update price if we have selected options
    if (hasSelectedOptions) {
      console.log("Found pre-selected options, updating price...");
      window.updateTotalPrice();
    }
  }

  // Add to cart functionality
  if (addToCartButton) {
    addToCartButton.addEventListener('click', async () => {
      const loader = addToCartButton.querySelector('.loader-small');
      if (loader) loader.style.display = 'inline-block';

      try {
        const variantId = addToCartButton.dataset.variant;
        const inventoryStatus = addToCartButton.dataset.inventoryStatus || '';
        
        // Get stored options data
        const storedData = JSON.parse(localStorage.getItem('product_builder_options')) || {};
        
        // Prepare items array with main product and its properties
        const items = [{
          id: variantId,
          quantity: 1,
          properties: {
            Variant: variantId,
            _InventoryStatus: inventoryStatus
          }
        }];

        // Add selected options to items array - use the current variant ID as the key
        if (storedData[variantId] && storedData[variantId].selected_product_options.length > 0) {
          storedData[variantId].selected_product_options.forEach(optionId => {
            items.push({
              id: optionId,
              quantity: 1,
              properties: {
                Parent: variantId
              }
            });
          });
        }

        // Send single request with all items
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items })
        });

        if (!response.ok) {
          const result = await response.json();
          throw new Error(result.description);
        }

        await showCartPopup();
      } catch (error) {
        console.error('Error adding to cart:', error);
        alert('Sorry, there was an error adding items to cart. Please try again.');
      } finally {
        if (loader) loader.style.display = 'none';
      }
    });
  }

  // Handle enquiry button click
  if (enquiryButton) {
    enquiryButton.addEventListener('click', function(e) {
      // Don't prevent default - let Tally handle it
      
      // Get current dynamic price from the price container
      const currentPrice = priceContainer.textContent.trim();
      
      // Update the data-price attribute with the current dynamic price
      this.setAttribute('data-price', currentPrice.replace('£', ''));
      
      // Collect selected options
      const selectedOptions = [];
      
      // Process radio buttons and checkboxes in product builder sections
      document.querySelectorAll('.product-builder-options').forEach(optionSection => {
        // Get section title
        const sectionTitle = optionSection.querySelector('.add-on-options-title')?.textContent.trim() || '';
        
        // Find selected options in this section
        const selectedInputs = optionSection.querySelectorAll('input.product-option-checkbox-input:checked');
        
        if (selectedInputs.length > 0) {
          selectedInputs.forEach(input => {
            // Find the parent label to get option details
            const optionContainer = input.closest('.option-label');
            if (optionContainer) {
              const titleElement = optionContainer.querySelector('.fw-600.mb-0.mt-0');
              const priceElement = optionContainer.querySelector('.mb-0.mt-0.fw-600');
              
              if (titleElement && priceElement) {
                const optionName = titleElement.textContent.trim();
                const optionPrice = priceElement.textContent.trim();
                
                selectedOptions.push(`${sectionTitle}: ${optionName} (${optionPrice})`);
              }
            }
          });
        }
      });
      
      // Get active variant
      const activeVariant = document.querySelector('.variant-link.active');
      if (activeVariant) {
        const variantTitle = activeVariant.querySelector('p')?.textContent.trim() || '';
        const variantSection = document.querySelector('.variant-links-title')?.textContent.trim() || 'Variant';
        
        if (variantTitle) {
          selectedOptions.unshift(`${variantSection}: ${variantTitle}`); // Add variant at the beginning
        }
      }
      
      // Join all options into a formatted string
      let optionsString = selectedOptions.length > 0 ? 
        selectedOptions.join(' | ') : 
        'Base product only';
      
      console.log('Selected options:', optionsString); // Debug output
      
      // Add selected options and total price to data attributes
      this.setAttribute('data-options', optionsString);
      this.setAttribute('data-total-price', currentPrice);
    });
  }

  // Make updateTotalPrice available globally for variant switching
  window.updateTotalPrice = function() {
    const currentPriceContainer = document.querySelector('.product-current-price');
    const currentCompareAtPriceContainer = document.querySelector('.product-compare-price');
    const currentProductOptionCheckboxes = document.querySelectorAll('.product-option-checkbox-input');

    // Skip price updates if price is hidden
    if (currentPriceContainer && currentPriceContainer.dataset.hidePrice === 'true') {
      return;
    }

    let basePrice = parseFloat(currentPriceContainer.dataset.basePrice);
    let comparePrice = currentCompareAtPriceContainer ? parseFloat(currentCompareAtPriceContainer.dataset.comparePrice) : 0;

    console.log("Updating price, base price:", basePrice);

    currentProductOptionCheckboxes.forEach(option => {
      if (option.checked) {
        const optionPrice = parseFloat(option.dataset.price) || 0;
        console.log(`Adding option price: ${optionPrice} for ${option.id}`);
        basePrice += optionPrice;
        if (comparePrice > 0) comparePrice += optionPrice;
      }
    });

    console.log("New total price:", basePrice);
    currentPriceContainer.textContent = formatMoney(basePrice);
    if (currentCompareAtPriceContainer && comparePrice > 0) {
      currentCompareAtPriceContainer.textContent = formatMoney(comparePrice);
    }
  }

  function formatMoney(amount) {
    return '£' + (amount/100).toFixed(2);
  }

  async function showCartPopup() {
    const cartPopup = document.querySelector('.cart-popup');
    if (cartPopup) {
      if (typeof getCartItems === 'function') {
        await getCartItems();
      }
      cartPopup.style.display = "block";
    }
  }

  // Function to clear options and reinitialize for variant changes
  window.clearAndReinitializeOptions = function() {
    // Clear all option selections
    productOptionCheckboxes.forEach(option => {
      option.checked = false;
      option.closest('.option-label')?.classList.remove('selected');
    });
    
    // Reinitialize with new variant
    initializeWithSelectedOptions();
  };

  // Make a second call to initializeWithSelectedOptions after a short delay
  // This is a fallback in case the initial call happens too early in the page lifecycle
  setTimeout(function() {
    initializeWithSelectedOptions();
  }, 500);
});